import { FC } from "react";
import { Badge, Card, IconButton, Stack, Subheading, Tooltip } from "@contentful/f36-components";
import { SettingsIcon } from "@contentful/f36-icons";
import tokens from "@contentful/f36-tokens";
import { useSDK } from "@contentful/react-apps-toolkit";
import { isFormalityEnabled, isGlossaryEnabled } from "../../lib";
import styles from "./PremiumCard.module.css";

interface PremiumCardProps {
    isInSidebar?: boolean;
    children: React.ReactNode;
}

export const PremiumCard: FC<PremiumCardProps> = ({ isInSidebar, children }) => {
    const sdk = useSDK();

    if (!isFormalityEnabled && !isGlossaryEnabled) {
        return null;
    }

    return (
        <Card
            style={{
                marginBottom: tokens.spacingL,
                backgroundColor: tokens.purple200,
                border: "none",
            }}>
            <Stack
                flexDirection="column"
                alignItems="stretch"
                spacing={isInSidebar ? "spacingXs" : "spacingL"}>
                <Stack justifyContent="space-between" fullWidth>
                    <Stack spacing="spacingXs">
                        <Subheading
                            fontColor="purple500"
                            marginBottom="none"
                            fontSize="fontSizeXlHigh">
                            Premium
                        </Subheading>
                        <Tooltip
                            content="Premium features are available to everyone during beta"
                            targetWrapperClassName={styles.betaBadge}>
                            <Badge
                                style={{
                                    backgroundColor: tokens.purple100,
                                    color: tokens.purple500,
                                    border: `solid 1px ${tokens.purple300}`,
                                }}>
                                Beta
                            </Badge>
                        </Tooltip>
                    </Stack>
                    {isInSidebar && (
                        <IconButton
                            icon={<SettingsIcon variant="premium" />}
                            aria-label="Go to configuration screen"
                            size="small"
                            withTooltip
                            tooltipProps={{
                                content: "Configure global premium settings",
                            }}
                            onClick={sdk.navigator.openAppConfig}
                        />
                    )}
                </Stack>
                {children}
            </Stack>
        </Card>
    );
};
